import React from "react";
import {withStyles} from "@mui/styles";
import {CircularProgress, Grid} from "@mui/material";
import {actions as dashboardActions, selectors as dashboardSelectors} from '../../../Ducks/dashboard';
import {actions as opportunitiesActions, selectors as opportunitiesSelectors} from '../../../Ducks/opportunity';
import {selectors as accountSelectors} from '../../../Ducks/account';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import SalesRep from "./Widgets/SalesRep";
import Memberships from "./Widgets/MemberShips";
import Placement from "./Widgets/Placement";
import Calendar from "../../Containers/Calendar/Widgets/CalendarWidget/Calendar";
import {getWeekStartEndDate} from "../../Utils/dateUtils";

const useStyles = (_theme) => ({});

class MainScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modelOpen: false,
            selectedItem: null,
            propsData: props,
            legacyEvents: [],
            legacyFollowUps: []
        };
    }

    componentDidMount() {
        this.getDashboardData();
    }

    componentDidUpdate(prevProps, _prevState) {
        let {calendar, followUps} = this.props;

        if (prevProps.calendar != calendar) {
            if (calendar) {
                if (Array.isArray(calendar)) {
                    this.setState({"legacyEvents": calendar});
                } else if (calendar.data.main) {
                    this.setState({"legacyEvents": [calendar]});
                }
            }
        }

        if (prevProps.followUps != followUps) {
            if (followUps) {
                if (Array.isArray(followUps)) {
                    this.setState({"legacyFollowUps": followUps});
                } else if (followUps) {
                    this.setState({"legacyFollowUps": [followUps]});
                }
            }
        }
    }

    getDashboardData = () => {
        const {getDashboard, getPipelines, user, getTags} = this.props;
        getDashboard();
        getTags();
        this.getCalendarData();


        if (user && user.user_details.user_id) {
            getPipelines(user.user_details.user_id);
        }
    }

    getCalendarData = () => {
        const {getAllEvents} = this.props;
        getAllEvents(getWeekStartEndDate(new Date()));
    }

    render() {
        const {
            dashboard,
            cronofyAuthorized,
            getAllEvents_loading,
            events,
        } = this.props;
        return (
            <div className="dashboard">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid className="salesrep-widget" item xs={6}>
                                <SalesRep dashboard={dashboard}/>
                            </Grid>
                            <Grid item xs={6}>
                                {
                                    (getAllEvents_loading) ? <CircularProgress/> :
                                        (
                                            <Calendar {...this.props} events={cronofyAuthorized ? events : []}
                                                      legacy_events={this.state.legacyEvents}/>
                                        )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className="membership-widget" item xs={6}>
                        <Memberships dashboard={dashboard}/>
                    </Grid>
                    <Grid className="placement-widget" item xs={6}>
                        <Placement dashboard={dashboard}/>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    dashboard: dashboardSelectors.dashboard(state),
    user: accountSelectors.user(state),
    calendar: opportunitiesSelectors.calendar(state),
    events: opportunitiesSelectors.events(state),
    getAllEvents_loading: opportunitiesSelectors.getAllEvents_loading(state),
    getAllEvenets_inProgress: opportunitiesSelectors.getAllEvenets_inProgress(state),
    cronofyAuthorized: accountSelectors.cronofyAuthorized(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getDashboard: dashboardActions.getDashboard,
        getPipelines: dashboardActions.getPipelines,
        getAllEvents: opportunitiesActions.getAllEvents,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(MainScreen));
